import FragmentPage from '../core/FragmentPage';

const FEED_URL = 'https://feeds.behold.so/Ex0WPHf4lV6ETlx97ky4';

const esc = (str) =>
  String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const safeUrl = (url) => (/^https:\/\//.test(url) ? url : '#');

export default class RedesSocialesPage extends FragmentPage {
  constructor(meta) {
    super('redes-sociales', meta);
  }

  async onEnter(context) {
    const grid = context.content.querySelector('.instagram-grid');
    if (!grid) return;

    try {
      const response = await fetch(FEED_URL);
      if (!response.ok) throw new Error('Feed unavailable');
      const { posts, username, profilePictureUrl } = await response.json();

      grid.innerHTML = posts.slice(0, 3).map((post) =>
        this.renderPost(post, username, profilePictureUrl)
      ).join('');
    } catch {
      grid.innerHTML =
        '<p class="instagram-grid__fallback">Síguenos en ' +
        '<a href="https://www.instagram.com/cinetikaespacio" target="_blank" rel="noopener noreferrer">@cinetikaespacio</a></p>';
    }
  }

  renderPost(post, username, profilePictureUrl) {
    const isVideo  = post.mediaType === 'VIDEO';
    const imgSrc   = safeUrl(isVideo ? (post.thumbnailUrl || post.mediaUrl) : post.mediaUrl);
    const href     = safeUrl(post.permalink);
    const caption  = post.prunedCaption || post.caption || '';
    const alt      = esc(caption ? caption.substring(0, 120) : 'Publicación de Instagram');
    const user     = esc(username || 'cinetikaespacio');
    const avatar   = safeUrl(profilePictureUrl || '');
    const videoMod = isVideo ? ' ig-post__media--video' : '';

    const avatarHtml = avatar !== '#'
      ? `<img class="ig-post__avatar" src="${esc(avatar)}" alt="${user}">`
      : `<div class="ig-post__avatar ig-post__avatar--placeholder"></div>`;

    const captionHtml = caption
      ? `<p class="ig-post__caption"><strong>${user}</strong> ${esc(caption)}</p>`
      : '';

    return `
<div class="ig-post">
  <div class="ig-post__header">
    ${avatarHtml}
    <span class="ig-post__username">${user}</span>
    <a class="ig-post__header-link" href="https://www.instagram.com/cinetikaespacio" target="_blank" rel="noopener noreferrer">Ver perfil</a>
  </div>
  <a class="ig-post__media${videoMod}" href="${esc(href)}" target="_blank" rel="noopener noreferrer">
    <img class="ig-post__image" src="${esc(imgSrc)}" alt="${alt}">
  </a>
  <div class="ig-post__footer">
    <div class="ig-post__actions">
      <svg class="ig-post__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
      <svg class="ig-post__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    </div>
    ${captionHtml}
  </div>
</div>`;
  }
}
